import React, { useEffect, useState, useRef, useMemo } from 'react'
import { toast } from 'react-toastify'

import { DragDropProvider } from '@react-page/core/lib'

import { DELETE, useClient } from '@peracto/client'

import { TextInput } from '@peracto/peracto-editor-ui'

import LibraryBlock from './LibraryBlock'

import * as S from './styled'

const ContentBlockLibrary = ({ editor, getLibraryBlocks, libraryBlocks, error, plugins }) => {
    const { client } = useClient()
    const [blockFilter, setBlockFilter] = useState('')
    const filterInput = useRef(null)

    const filterBlocks = blocks =>
        blocks.filter(block => {
            return block.name.toLowerCase().includes(blockFilter)
        })

    const deleteItem = item => async () => {
        try {
            await client(DELETE, 'contents', {
                id: item.id,
            })
            getLibraryBlocks(true)
            toast.success(`Successfully deleted the item ${item.name}`)
        } catch (e) {
            console.error(e)
            toast.error(`There was an issue deleting "${item.name}"`)
        }
    }

    useEffect(() => {
        filterInput.current?.focus()
    }, [])

    const content = useMemo(
        () => (
            <>
                <TextInput
                    ref={filterInput}
                    label="Filter Blocks"
                    onChange={e => setBlockFilter(e.target.value.toLowerCase())}
                />
                <DragDropProvider>
                    <S.ContentBlockList fullWidth={true}>
                        {libraryBlocks.length > 0 ? (
                            <>
                                {filterBlocks(libraryBlocks).map(block => (
                                    <LibraryBlock
                                        block={block}
                                        editor={editor}
                                        key={block.id}
                                        handleDelete={deleteItem}
                                        plugins={plugins}
                                    />
                                ))}
                            </>
                        ) : (
                            <p className="!w-full !text-center">You have no saved Templates</p>
                        )}
                    </S.ContentBlockList>
                </DragDropProvider>
            </>
        ),
        [libraryBlocks, blockFilter]
    )

    if (error) {
        return (
            <div className="alert alert-danger !m-1" role="alert">
                There was an issue getting the library.
            </div>
        )
    }

    return content
}

export default ContentBlockLibrary
